import React, { useState, useEffect } from 'react';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import LocalModal from 'components/base/local-modal';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { getFullName, handleApiError } from 'utils/functions';
import SelectDropdown from 'components/base/select-dropdown';
import { MemberListType } from 'models/member.model';

const AddRole = ({
  show,
  onClose,
  updateAdminList
}: {
  show: boolean;
  onClose: () => void;
  updateAdminList: (newData: MemberListType[]) => void;
}) => {
  const role = { name: '', id: '' };
  const [roles, setRoles] = useState([role]);
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState<MemberListType[]>([]);
  const { activeCompany } = useDashboardContext();
  const companyId = activeCompany?.id;

  const addNewRoles = () => {
    setRoles([...roles, role]);
  };

  const fetchAllMembers = async () => {
    if (!companyId) return;
    try {
      setLoading(true);
      const res = await apiService.get('member', {
        params: {
          company_id: companyId
        }
      });
      if (res) {
        const members = res?.data?.data?.results?.filter((item: any) => item.role === 'MEMBER');
        setMembers(members);
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllMembers();
  }, [companyId]);

  const handleChange = (item: { name: string; id: string }, i: number) => {
    const arr: any = [...roles];
    arr[i].name = item.name;
    arr[i].id = item.id;
    setRoles([...arr]);
  };

  const editRoles = async () => {
    setLoading(true);
    const data = {
      member_ids: roles.map((item) => item.id)
    };
    try {
      const res = await apiService.put(`member/send-bulk-invitation`, {
        data
      });
      if (res.status === 200) {
        const selectedMemberIds = data.member_ids;
        updateAdminList(members.filter((item) => selectedMemberIds.includes(item.id)));
        toast(<ToastMessage type='success' message='Admins invited successfully' />);
        setRoles([role]);
        onClose();
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <LocalModal
      isOpen={show}
      title='Add roles'
      description={``}
      onRequestClose={() => onClose()}
      footer={
        <div className='flex gap-5 justify-end '>
          <Button onClick={onClose} className='w-[130px]' color='gray' small variant='block'>
            Cancel
          </Button>
          <Button
            loading={loading}
            className='w-[130px]'
            color='primary'
            small
            variant='block'
            onClick={editRoles}>
            Confirm
          </Button>
        </div>
      }>
      <div>
        {roles?.map((item, index) => (
          <SelectDropdown
            key={index}
            label='Name'
            options={members.map((item) => ({
              id: item.id,
              name: getFullName(item.user)
            }))}
            value={item.name}
            setValue={(value) => handleChange(value, index)}
            placeholder='Donatus Globus'
            hasSearch
            subAction={
              index >= 1 && (
                <button
                  className=' text-[#E60A2B] text-[13px] font-[500]'
                  onClick={() =>
                    setRoles((prev: any) => prev.filter((obj: any, i: number) => i !== index))
                  }>
                  - Remove admin
                </button>
              )
            }
          />
        ))}

        <button onClick={addNewRoles} className='text-[#0080E5] mt-2'>
          + Add roles
        </button>
      </div>
    </LocalModal>
  );
};

export default AddRole;
